import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationAreaComponent } from './organization-area.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationService } from './services/organization.service';
import { OrganizationDetailsPageComponent } from './components/organization-details-page/organization-details-page.component';
import { OrganizationMembersPageComponent } from './components/organization-members-page/organization-members-page.component';
import { OrganizationCreditsPageComponent } from './components/organization-credits-page/organization-credits-page.component';
@NgModule({
    declarations: [
        OrganizationAreaComponent,
        OrganizationDetailsPageComponent,
        OrganizationMembersPageComponent,
        OrganizationCreditsPageComponent,
    ],
    exports: [OrganizationAreaComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatDialogModule,
        ClipboardModule,
        NgbPaginationModule,
    ],
    providers: [OrganizationService],
})
export class OrganizationAreaModule {}
